// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CheckInController from "./check_in_controller"
application.register("check-in", CheckInController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import SeatController from "./seat_controller"
application.register("seat", SeatController)

import SeatEditorController from "./seat_editor_controller"
application.register("seat-editor", SeatEditorController)

import SeatingPlanController from "./seating_plan_controller"
application.register("seating-plan", SeatingPlanController)
